import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';
import InputText from 'modules/_shared/components/InputText';
import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';

const TestEmailPanel: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useNotifyPartnersDividendsModal();

  return (
    <div className={`slide-panel  ${data.showTestEmailPanel ? 'open' : ''}`}>
      <div className="panel-inner">
        <div className="input-row">
          <InputText
            id="test-email"
            placeholder={t('Email')}
            value={data.testEmailRecipient}
            onChange={actions.handleChangeTestEmailRecipient}
            emailInput
            marginBottom={0}
          />

          <Button
            variant={ButtonVariants.LIGHT}
            onClick={actions.handleSendTestEmail}
            disabled={data.invalidEmail || !data.testEmailRecipient.trim()}
            lgSize
          >
            {t('Send')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TestEmailPanel;
